let options = {
    itemContainerSelector: '.entity-list-vertical--container',
    itemSelector: '.entity-list-vertical--item',
    loadmoreSelector: '.entity-list-vertical--loadMore',
    loadmoreLabelSelector: '.entity-list-vertical--loadMoreLabel'
};

const eventHandler = {
    loadmore: (itemContainer, loadMoreBtn, loadMoreLabel) => {
        const hiddenItems = itemContainer.querySelectorAll(options.itemSelector + '.d-none');

        for (let i = 0; i < hiddenItems.length && i < 12; i++) {
            hiddenItems[i].classList.remove('d-none');
        }

        if (hiddenItems.length <= 12) {
            loadMoreBtn.classList.add('d-none');
        }

        const visibleItems = itemContainer.querySelectorAll(options.itemSelector + ':not(.d-none)');
        loadMoreLabel.textContent = visibleItems.length + ' ' + window.jsI18N?.productfinder?.labels?.of + ' ' + (itemContainer.children.length - 1) + ' ' + loadMoreBtn.dataset.entityname;

        return false;
    }
};

const verticalList = {
    init: (overwriteOptions) => {
        options = Object.assign(options, overwriteOptions);
        const self = this;

        const itemContainers = document.querySelectorAll(options.itemContainerSelector);
        itemContainers.forEach(itemContainer => {
            const loadMoreBtn = itemContainer.querySelector(options.loadmoreSelector);
            const loadMoreLabel = itemContainer.querySelector(options.loadmoreLabelSelector);
            if (loadMoreBtn !== null) {
                loadMoreBtn.addEventListener('click', eventHandler.loadmore.bind(self, itemContainer, loadMoreBtn, loadMoreLabel));
                const visibleItems = itemContainer.querySelectorAll(options.itemSelector + ':not(.d-none)');
                loadMoreLabel.textContent = visibleItems.length + ' ' + window.jsI18N?.productfinder?.labels?.of + ' ' + (itemContainer.children.length - 1) + ' ' + loadMoreBtn.dataset.entityname;
            }
        });
    }
};

export { verticalList };
